import React from "react";

import Reveal from "../motion/Reveal";
import { Eyebrow, Button } from "../ui/primitives";

// Opening block of every page. Same anatomy throughout, only the scale of the
// title changes: the home page gets the largest setting, service and legal
// pages step down.
//
// This is the one place on the site that animates without waiting for a
// scroll, because it is already in view on load. The stagger is what gives the
// page its sense of arriving rather than appearing.

export default function PageHero({
  eyebrow,
  title,
  lede,
  cta,
  meta,
  size = "page",
  align = "start",
}) {
  const centred = align === "center";

  return (
    <section className={`shell pt-16 pb-12 sm:pt-20 lg:pt-24 lg:pb-16 ${centred ? "text-center" : ""}`}>
      <div className={`flex flex-col gap-6 ${centred ? "items-center" : "items-start"}`}>
        {eyebrow && (
          <Reveal delay={0} distance={8}>
            <Eyebrow pulse>{eyebrow}</Eyebrow>
          </Reveal>
        )}

        <Reveal delay={80}>
          <h1 className={`${size === "hero" ? "t-hero" : "t-display"} max-w-[920px]`}>{title}</h1>
        </Reveal>

        {lede && (
          <Reveal delay={160}>
            <p className="t-lede max-w-[700px]">{lede}</p>
          </Reveal>
        )}

        {meta && (
          <Reveal delay={200} distance={8}>
            <div className="flex items-center gap-2.5">
              <span className="t-label">{meta.label}</span>
              <span className="h-px w-6 bg-line" aria-hidden="true" />
              <span className="font-mono text-[12.5px] text-fg-secondary">{meta.value}</span>
            </div>
          </Reveal>
        )}

        {cta && (
          <Reveal delay={240} className="pt-1">
            <Button to={cta.to} variant={cta.variant || "accent"}>
              {cta.label}
            </Button>
          </Reveal>
        )}
      </div>
    </section>
  );
}
